import React, { useRef, useState } from "react";

import styled from "styled-components";
import { Colors } from "utils/colors";
import Typography from "components/typography";
import { FormatAudioDuration } from "utils/dateConvert";
import ToggleAudio from "components/toggleAudio";
import GrayCard from "components/gray-card";

interface IProps {
  audio: File;
}
const AudioFile = ({ audio }: IProps) => {
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleLoadedMetadata = (event: any) => {
    const audioDuration = event.target.duration;
    setDuration(audioDuration);
  };

  const handleTimeUpdate = (event: any) => {
    const current = event.target.currentTime;
    setCurrentTime(current);
  };

  const TogglePlay = () => {
    if (audioRef.current && !isPlaying) {
      audioRef.current.play();
      setIsPlaying(true);
    }
    if (audioRef.current && isPlaying) {
      setIsPlaying(false);
      audioRef.current.pause();
    }
  };
  return (
    <GrayCard title="Audio File">
      <audio
        controls
        onLoadedMetadata={handleLoadedMetadata}
        onTimeUpdate={handleTimeUpdate}
        style={{ display: "none" }}
        ref={audioRef}
      >
        <source src={URL.createObjectURL(audio)} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
      <AudioFileContainer>
        <PlayTimeContainer>
          <ToggleAudio toggleAudio={TogglePlay} />

          <Typography color={Colors.grey500} size="xs" mt="0.4">
            {FormatAudioDuration(duration)}
          </Typography>
        </PlayTimeContainer>
        <AudioFileText>
          <Typography size="s" weight="medium" mb="0.4">
            {audio.name}
          </Typography>
        </AudioFileText>
      </AudioFileContainer>
    </GrayCard>
  );
};

export default AudioFile;

const AudioFileContainer = styled.div`
  padding: 0.8rem 2rem;
  border-radius: 0.8rem;
  background: ${Colors.grey600};
  display: flex;
  align-items: center;
`;

const PlayTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 2.4rem;
`;

const PlayButton = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: ${Colors.yellow500};
  cursor: pointer;
  margin-bottom: 0.4rem;
`;

const AudioFileText = styled.div``;
